import { useState, useEffect } from "react";
import {
  successToast,
  failureToast,
} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { autoCancelChequeApi, depositChequeApi } from "../api";

export const formatRequest = ({
  totalAmount,
  selectedReceipts,
  businessAreaId,
  accountDetails,
  depositSlipNumber
}) => {
  return {
    businessAreaValue: businessAreaId,
    cashierOffice: businessAreaId,
    receiptIds: selectedReceipts.map((item) => item.id),
    slipS3Key: "  ",
    bankName: accountDetails.bankName?.value,
    accountNumber: accountDetails.accountNumber?.value,
    totalAmount: totalAmount,
    depositSlipNumber
  };
};

export const useDepositCheque = () => {
  const [loading, setLoading] = useState(false);

  const depositCheque = async (
    formState,
    onSuccess = () => {},
    onError = () => {}
  ) => {
    try {
      setLoading(true);
      const request = formatRequest(formState);
      const res = await depositChequeApi(request);

      if (res?.code === 200) {
        successToast(res?.message || "Deposit cheque successfully");
        onSuccess(res?.data);
      } else {
        failureToast(res?.message || "Something went wrong");
        onError(res);
      }
    } catch (err) {
      console.error(err);
      failureToast("Unable to deposit cheque. Please try again.");
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  return { depositCheque, loading };
};

export const useGetChequeDetails = ({ applicationId }) => {
  const [loading, setLoading] = useState(false);
  const [chequeReceipts, setChequeReceipts] = useState([]);

  const getChequeDetails = async (referenceNumber) => {
    try {
      setLoading(true);
      const res = await autoCancelChequeApi(referenceNumber);
      if (res?.chequeNoList?.length>0) {
        setChequeReceipts(res);
      } else {
        setChequeReceipts([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (applicationId) getChequeDetails(applicationId);
  }, [applicationId]);

  return { chequeReceipts, loading };
};
